import Logo from "@/components/site/Logo";

/**
 * Pure-CSS loader: dismisses via animation on the document timeline
 * (robust even when JS timers/rAF are throttled in background tabs).
 */
const Loader = () => {
  return (
    <div
      data-testid="page-loader"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-white"
      style={{
        animation: "loaderExit 2.4s cubic-bezier(0.83,0,0.17,1) forwards",
        pointerEvents: "none",
      }}
    >
      <div className="hero-fade mb-8" style={{ animationDelay: "0.1s" }}>
        <Logo className="h-10 md:h-12 w-auto" />
      </div>
      <div className="h-[2px] w-48 overflow-hidden rounded-full bg-gold-soft/50">
        <div
          className="h-full btn-gold"
          style={{ animation: "loaderBar 1.3s cubic-bezier(0.16,1,0.3,1) forwards" }}
        />
      </div>
    </div>
  );
};

export default Loader;
